import styled from 'styled-components';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const Container = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 440px;
  padding: 16px;
  position: relative;
  text-align: center;

  @media (max-width: 768px) {
    padding-top: 40px;
  }
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 28px;
    height: 2px;
    background: #333;
    transform-origin: center;
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  @media (max-width: 768px) {
    top: -60px;
    right: 50%;
    transform: translateX(50%);
    width: 32px;
    height: 32px;
    background: #1d1d1d;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    &:before,
    &:after {
      width: 16px;
      background: #ffffff;
    }
  }
`;

const Content = styled.div`
  font-size: 16px;
  color: #333;
`;

export { Backdrop, Container, CloseIcon, Content };
